import { TextEditor } from 'components/TextEditor'
import { FieldStackItem, FormStack } from 'forms/FormStack'
import * as React from 'react'

export const ProvingDetailsAnnotationForm: React.FC = () => {
  // const { t } = useTranslation()
  return (
    <FormStack>
      <FieldStackItem
        name="annotation"
        render={(fieldProps) => (
          <TextEditor
            value={fieldProps.field.value}
            onChange={(value) => {
              fieldProps.form.setFieldValue('annotation', value || '')
            }}
          />
        )}
      />
    </FormStack>
  )
}
